import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-browser-plugin',
  templateUrl: './browser-plugin.component.html',
  styleUrls: ['./browser-plugin.component.scss']
})
export class BrowserPluginComponent implements OnInit {
  documentMode: any;
  navigator: any;
  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
    ) { }

    ngOnInit() {
      this.titleService.setTitle('무료 문법 검사 브라우저 Chrome, Firefox, Safari 전용 플러그인 - 트링카');
      this.metaTagService.updateTag({ name: 'description', content: '트링카 플러그인은 Google Chrome, Mozilla Firefox 및 Safari Browser에서 무료로 사용 가능합니다. 문법상의 오류를 미리 수정하고 고치고 문맥에 맞는 단어까지 제한해 주는 트링카로 효과적인 글 쓰기를 그 어느 때보다 쉽게 시작할 수 있습니다.' });
      this.metaTagService.updateTag({ property: 'og:title', content: '브라우저용 트링카 플러그인 ' });
      this.metaTagService.updateTag({ property: 'og:description', content: 'Chrome, Firefox 및 Safari Browser 전용 트링카 플러그인을 무료로 설치하고 사용해 보세요. 학문적 영문법까지 모든 오류를 수정합니다. ' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/browser-plugin' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/BrowserPlugin_banner.png' });
      this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
      this.metaTagService.updateTag({ name: 'twitter:title', content: '무료 문법 검사 브라우저 Chrome, Firefox, Safari 전용 플러그인 - 트링카' });
      this.metaTagService.updateTag({ name: 'twitter:description', content: "트링카 플러그인은 Google Chrome, Mozilla Firefox 및 Safari Browser에서 무료로 사용 가능합니다. 문법상의 오류를 미리 수정하고 고치고 문맥에 맞는 단어까지 제한해 주는 트링카로 효과적인 글 쓰기를 그 어느 때보다 쉽게 시작할 수 있습니다." });
      this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/BrowserPlugin_banner.png' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/browser-plugin' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/browser-plugin' });
      if (isPlatformBrowser(this.platformId)){
        // $.getScript('../../../assets/js/particles.min.js', function(){});
        // $.getScript('../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../assets/js/owl.carousel.min.js', function () {});     
      $.getScript('../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../assets/js/browser.js', function () { });
        const userAgent = window.navigator.userAgent;
        console.log(this.myBrowser());
      }
      
    }
    myBrowser() {
      if (isPlatformBrowser(this.platformId)){
        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
          $("#BrowserGoogleChromeSection").css("display", "none");
          $("#BrowserFirefoxSection").css("display", "none");
          $("#BrowserEdgeBrowserSection").css("display", "none");
          $("#BrowserGoogleChromeSection_cta").css("display", "none");
          $("#BrowserFirefoxSection_cta").css("display", "none");
          $("#BrowserEdgeBrowserSection_cta").css("display", "none");
          return 'Opera';
    
        } else if (navigator.userAgent.indexOf("Chrome") != -1) {
          $("#BrowserGoogleChromeSection").css("display", "block");
          $("#BrowserFirefoxSection").css("display", "none");
          $("#BrowserEdgeBrowserSection").css("display", "none");
          $("#BrowserGoogleChromeSection_cta").css("display", "block");
          $("#BrowserFirefoxSection_cta").css("display", "none");
          $("#BrowserEdgeBrowserSection_cta").css("display", "none");
          return 'Chrome';
    
        } else if (navigator.userAgent.indexOf("Safari") != -1) {
          $("#BrowserGoogleChromeSection").css("display", "none");
          $("#BrowserFirefoxSection").css("display", "none");
          $("#BrowserEdgeBrowserSection").css("display", "none");
          $("#BrowserGoogleChromeSection_cta").css("display", "none");
          $("#BrowserFirefoxSection_cta").css("display", "none");
          $("#BrowserEdgeBrowserSection_cta").css("display", "none");
          return 'Safari';
    
        } else if (navigator.userAgent.indexOf("Firefox") != -1) {
          $("#BrowserGoogleChromeSection").css("display", "none");
          $("#BrowserFirefoxSection").css("display", "block");
          $("#BrowserEdgeBrowserSection").css("display", "none");
          $("#BrowserGoogleChromeSection_cta").css("display", "none");
          $("#BrowserFirefoxSection_cta").css("display", "block");
          $("#BrowserEdgeBrowserSection_cta").css("display", "none");
          return 'Firefox';
    
        }
        else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
          $("#BrowserGoogleChromeSection").css("display", "none");
          $("#BrowserFirefoxSection").css("display", "none");
          $("#BrowserEdgeBrowserSection").css("display", "block");
          $("#BrowserGoogleChromeSection_cta").css("display", "none");
          $("#BrowserFirefoxSection_cta").css("display", "none");
          $("#BrowserEdgeBrowserSection_cta").css("display", "block");
          return 'IE';
        }
        else {
          return 'unknown';
        }      
      }
    }
    ngAfterViewInit(){
      if (isPlatformBrowser(this.platformId)){
        $.getScript('../../../assets/js/home_client_slider.js', function () { });
      }
    }

    generateGuid() {
      var result, i, j;
      result = '';
      for(j=0; j<32; j++) {
        if( j == 8 || j == 12 || j == 16 || j == 20)
          result = result + '-';
        i = Math.floor(Math.random()*16).toString(16).toUpperCase();
        result = result + i;
      }
      return result;
    }

}
